import { getAnalysisIcon } from '@modules/analysis/helpers';
import { getAnalysisTypeDisplayName } from '@modules/dashboard/helpers';
import { LinkRounded } from '@mui/icons-material';
import { Button, IconButton, Stack, Tooltip } from '@mui/material';
import {
  AnalysisUseCase,
  PermissionOperation,
  PermissionResource,
} from 'generated/graphql';
import { CanAccess } from '../CanAccess';

interface AnalysisFeedbackListDrawerSecondaryNodeProps {
  useCase: AnalysisUseCase;
  onCopy: () => void;
  onCreateNewArtefact?: () => void;
}

export const AnalysisFeedbackListDrawerSecondaryNode = ({
  useCase,
  onCopy,
  onCreateNewArtefact,
}: AnalysisFeedbackListDrawerSecondaryNodeProps) => {
  const analysisTypeDisplayName = getAnalysisTypeDisplayName(useCase);
  const analysisIcon = getAnalysisIcon(useCase, {
    fontSize: 'small',
  });

  return (
    <Stack spacing={1} direction="row" alignItems="center">
      <Tooltip
        title={`Copy ${analysisTypeDisplayName} link`}
        disableInteractive
      >
        <IconButton onClick={onCopy} color="primary">
          <LinkRounded />
        </IconButton>
      </Tooltip>
      <CanAccess
        resource={PermissionResource.Artefact}
        operation={PermissionOperation.Write}
      >
        <Button
          variant="outlined"
          startIcon={analysisIcon}
          sx={{
            whiteSpace: 'nowrap',
            minWidth: 'max-content',
          }}
          onClick={onCreateNewArtefact}
        >
          Save
        </Button>
      </CanAccess>
    </Stack>
  );
};
